import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import { useSelector } from "react-redux";
import Snackbar from "../../../Snackbar";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    LampCeilingIcon,
    KanbanIcon,
    Joystick,
    PlugZap,
    XCircle,
    Quote,
    OctagonAlert,
    AirplayIcon,
    HopIcon,
    Activity} from 'lucide-react';
import LoadingButton from "../../Loading/LoadingButton";
import AppMenuCardBlue from "../AppCards/AppMenuCardBlue";

const ShowStartInfoCards = ({setActiveCardOverview,baseUrl})=>{
  const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();

   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [goNextPopUp, setGoNextPopUp] =useState(false);
 
 const showSnackbar = () => {
   setSnackbarVisible(true);
 };

 const hideSnackbar = () => {
   setSnackbarVisible(false);
 };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

 const [loader , setLoader] =useState({status:false});
 const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
 const [editType, setEditType] = useState(courseData?.ID?"videoLinks":"");
const videoLinks =courseData?.videoLinks?JSON.parse(courseData?.videoLinks):[];

 const [animate, setAnimate] = useState(false);

 let TypeTitle= courseData?.ID?courseData?.type=='course'?"Course":
  courseData?.type=='batch'?"Batch":
  courseData?.type=="testSeries"?"Test Series":
  courseData?.type=="homeTutor"?"":
  courseData?.type=="bundle"?"Bundle":
courseData?.type=="digitalProduct"?"Product":"":"Course";

let TypeLink= courseData?.ID?courseData?.type=='course'?"course-name":
courseData?.type=='batch'?"batch-name":
courseData?.type=="testSeries"?"test-series-name":
courseData?.type=="homeTutor"?"home-tutor-offering-name":
courseData?.type=="bundle"?"bundle-name":
courseData?.type=="digitalProduct"?"digital-product-name":"":"course-name";

 useEffect(() => {
    // console.log(itemArr)
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);
useEffect(()=>{
  setActiveCardOverview(true);
  
  // setCourseTitleData();
},[])



    
    
    
    
const handleBack=(e)=>{
  
    setLoader({status:true});
    
    history.goBack();
    }
    
    return <>
    
{<>
  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}

<div  className="ikcraft_login-signup-card-outerj"style={{}}> <div  className="CreateCourseStepsOuter contentPageScroller " style={{background:"#fff",borderRadius:"25px"}}>
<div style={{
        transform: animate ? 'translateY(0)' : 'translateY(50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 3s ease, opacity 3s ease',
      background:"#f9f9f9",borderRadius:"25px"}} > 

<div  className=""style={{overflow:"hidden",
transform: animate ? 'scale(1)' : 'scale(.9)',
opacity: animate ? 1 : 0,
transition: 'transform 2s ease, opacity 1s ease',padding:"10px"
}}>


<Activity size={60}   color="#958FDA" /> 

<div class="CreateCourseStepsOuterTitle"> Great To See You Here !!!  </div>
<h4> Select Any Of The Action For Your <span className="coloredTextV1" > {TypeTitle} </span>And Start Adding Info.  
</h4>

</div> 
<div align="left" className="itemCourseOuter" style={{overflow:"hidden",
transform: animate ?  'translateY(0)' : 'translateY(100px)',
opacity: animate ? 1 : 0,
transition: 'transform 2s ease, opacity 1s ease',padding:"10px"
,marginTop:"0px",marginBottom:"0px",background:"rgba(86, 82, 131,.8)"}}> 
                
                <div  className="whatToDoNextItemCardInner" ><div style={{background:"#fff",width:"50px",height:"50px",borderRadius:"50%",
                      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><HopIcon size={32}  color="rgb(86, 82, 131)"/></div> 
             
                <h2 style={{color:"#fff"}}>Next Phase</h2> 
                  
                
                </div>
                  <div  style={{display:"flex",justifyContent:"center"}}>
              <AppMenuCardBlue activeCard={""} icon={1} title ="Labels & More" onClickPopup={
          ()=>{  history.push(`${baseUrl}/labels`)
          }}  />
           </div> 
           </div> 
 
    </div>  
    <div  className="CreateCourseStepsOuterRight " >
    

 <div align="left" className="itemCourseOuter" style={{ transform: animate ? 'translateY(0)' : 'translateY(100px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',marginBottom:"40px",height:"70px" ,background:"rgba(144, 202, 249,0.1)"}}> 
<div  className="set-expiry-card-bottom"style={{justifyContent:"space-around",color:"#444444"}} >
<h2> Add   {TypeTitle} Title </h2> 
 <button 
 onMouseEnter={
  ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave}
  onClick={()=>{ 
    history.push(`/apps/${AppToken}/create/${TypeLink}`)
     

   }}  
 className="rightButtonSetItBlue"   type="submit"
 id="signupBtn"> <span className="" >Let's Add</span> </button>
  </div>
<div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div></div>
 </div>   </div>

 <div align="left" className="itemCourseOuter" style={{ transform: animate ? 'translateY(0)' : 'translateY(100px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1.5s ease, opacity 1.5s ease',marginBottom:"40px",height:"70px" ,background:"rgba(144, 202, 249,0.1)"}}> 
<div  className="set-expiry-card-bottom"style={{justifyContent:"space-around",color:"#444444"}} >
<h2> Add Contents</h2> 
 <button 
 onMouseEnter={
  ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave}
  onClick={()=>{ 
    history.push(`/apps/${AppToken}/create/approx-material`)
     

   }}  
 className="rightButtonSetItBlue"   type="submit"
 id="signupBtn"> <span className="" >Let's Add</span> </button>
  </div>
<div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div></div>
 </div>   </div>
 <div align="left" className="itemCourseOuter" style={{ transform: animate ? 'translateY(0)' : 'translateY(100px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 2s ease',marginBottom:"40px",height:"70px" ,background:"rgba(144, 202, 249,0.1)"}}> 
<div  className="set-expiry-card-bottom"style={{justifyContent:"space-around",color:"#444444"}} >
<h2>Add Thumbnails</h2> 
 <button 
 onMouseEnter={
  ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave}
  onClick={()=>{ 
    history.push(`/apps/${AppToken}/create/thumbnails`)
     

   }}  
 className="rightButtonSetItBlue"   type="submit"
 id="signupBtn"> <span className="" >Let's Add</span> </button>
  </div>
<div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div></div>
 </div>   </div>
 <div align="left" className="itemCourseOuter" style={{ transform: animate ? 'translateY(0)' : 'translateY(100px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2.5s ease, opacity 2.5s ease',marginBottom:"40px",height:"70px" ,background:"rgba(144, 202, 249,0.1)"}}> 
<div  className="set-expiry-card-bottom"style={{justifyContent:"space-around",color:"#444444"}} >
<h2> Add Demo Videos</h2> 
 <button 
 onMouseEnter={
  ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave}
  onClick={()=>{ 
    history.push(`/apps/${AppToken}/create/demo-videos`)
     

   }}  
 className="rightButtonSetItBlue"   type="submit"
 id="signupBtn"> <span className="" >Let's Add</span> </button>
  </div>
<div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div></div>
 </div>   </div>
    

<div style={{height:"70px"}}></div>
 </div>
 <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/labels`)}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/trial`)}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":productID?"Go Next":"Go Next"} </button>
     
  </div>
  </div></div>
</>}
    </>

}

export default ShowStartInfoCards;


